import { render, staticRenderFns } from "./Ver-informe.vue?vue&type=template&id=373d034d&scoped=true&"
import script from "./Ver-informe.vue?vue&type=script&lang=js&"
export * from "./Ver-informe.vue?vue&type=script&lang=js&"
import style0 from "./Ver-informe.vue?vue&type=style&index=0&id=373d034d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d034d",
  null
  
)

export default component.exports